<div class="flex flex-wrap justify-content-between align-items-center my-3">
  <div class="flex flex-column">
    <h2 class="m-0 font-semibold text-base">Campaigns</h2>
    <span class="sub-title mt-2">Manage notification campaigns and reusable templates.</span>
  </div>
  <div class="flex gap-2">
    <p-button label="Send notification" styleClass="send-btn" variant="outlined" (onClick)="sendNotificationDialog = true">
      <ng-template #icon>
        <i class="fa-solid fa-paper-plane"></i>
      </ng-template>
    </p-button>
    @if (activeTab() === '0') {
    <p-button styleClass="add-button text-xs" label="Add Template" severity="primary" (onClick)="onAddClick()">
      <ng-template #icon>
        <img width="15" height="15" src="assets/icons/Add.svg" alt="Add" />
      </ng-template>
    </p-button>
    }
  </div>
</div>

<div class="details-container">
  <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)" class="tabs--topics">
    <p-tablist>
      <p-tab value="0">Templates</p-tab>
      <p-tab value="1">Notification history</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <app-config-templates />
      </p-tabpanel>
      <p-tabpanel value="1">
        <app-notification-history />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>

<app-send-notification [(visibility)]="sendNotificationDialog" (sent)="onNotificationSent()" />
